import { StyleSheet } from 'react-native';
import SizeUtil from '../../../Utils/SizeUtil';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

export default StyleSheet.create({
    noDataWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: baseColor.background2
    },
    noDataContent: {
        position: 'absolute',
        top: SizeUtil.getHeightByPercent(0.22), // 高度是距离屏幕顶部的22%
        left: 0,
        right: 0,
        alignItems: 'center'
    },
    noDataImage: {
        height: 170,
        width: 250
    },
    noDataTitle: {
        marginTop:0,
        lineHeight: 18,
        color: baseColor.text3,
        fontSize: 14,
        textAlign: 'center'
    },
    noLoginTitle: {
        lineHeight: 18,
        color: baseColor.text3,
        fontSize: 14,
        textAlign: 'center'
    },
    noDataRedoButton: {
        width: 70,
        height: 32,
        marginTop: 20,
        borderRadius: 16,
        backgroundColor: '#09C8E0',
        justifyContent: 'center',
        alignItems: 'center'
    },
    noDataRedoButtonText: {
        fontSize: 15,
        textAlign: 'center',
        color: '#ffffff'
    }
});
